import { ApiManager } from '../core/api-manager';
import { Utils } from '../core/utils';

/**
 * Creazione di un condominio (`user_group`) e del suo primo amministratore.
 *
 * Non passa da DataManager perche' la CRUD del framework timbra ogni
 * inserimento con l'idUserGroup di chi scrive: l'utente finirebbe nel gruppo
 * di chi lo crea, non in quello appena nato. Ci pensa `CondominioEngine`.
 */
async function createCondominio(condominio, amministratore) {
    let body = {
        condominio: condominio,
        amministratore: {
            ...amministratore,
            // come ovunque nell'app la password viaggia gia' cifrata
            password: Utils.encrypt(amministratore.password)
        }
    }
    let response = await ApiManager.sendAuthenticatedRequest('/custom/create_condominio', body)
    return response;
}


/**
 * Nomina un altro amministratore di un condominio gia' esistente.
 *
 * Stesso motivo della creazione: dall'anagrafica utenti l'amministratore
 * globale creerebbe l'utente nel proprio gruppo. Serve quando un condominio
 * resta senza amministratore, o quando ne vuole un secondo.
 */
async function addAmministratore(idUserGroup, amministratore) {
    let body = {
        idUserGroup: idUserGroup,
        amministratore: {
            ...amministratore,
            password: Utils.encrypt(amministratore.password)
        }
    }
    let response = await ApiManager.sendAuthenticatedRequest('/custom/add_amministratore', body)
    return response;
}


/**
 * Amministratori di un condominio.
 *
 * Non passa da DataManager perche' l'elenco utenti della CRUD e' paginato:
 * su un'installazione con molti utenti gli amministratori del condominio
 * aperto potrebbero non essere nella prima pagina.
 */
async function listAmministratori(idUserGroup) {
    let body = { idUserGroup: idUserGroup }
    let response = await ApiManager.sendAuthenticatedRequest('/custom/amministratori_condominio', body)
    return response;
}


/**
 * Quante sale, palazzine, utenti... stanno dentro un condominio: la conferma
 * dell'eliminazione li mostra prima che spariscano.
 */
async function riepilogoCondominio(idUserGroup) {
    let body = { idUserGroup: idUserGroup }
    let response = await ApiManager.sendAuthenticatedRequest('/custom/riepilogo_condominio', body)
    return response;
}


/**
 * Elimina un condominio con tutto cio' che contiene.
 *
 * Non passa da DataManager perche' la CRUD cancellerebbe solo il condominio,
 * lasciando vivi sale, palazzine e utenti che gli appartengono.
 */
async function deleteCondominio(idUserGroup) {
    let body = { idUserGroup: idUserGroup }
    let response = await ApiManager.sendAuthenticatedRequest('/custom/delete_condominio', body)
    return response;
}


export const CondominiManager = {
    createCondominio: createCondominio,
    addAmministratore: addAmministratore,
    listAmministratori: listAmministratori,
    riepilogoCondominio: riepilogoCondominio,
    deleteCondominio: deleteCondominio
};
